<template>
  <div>
    <div class="text-end mt-3 mb-4">
      <button @click="addNew = !addNew" class="btn btn-outline-primary">
        {{ 'Add' | translate }}
      </button>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 col-lg-6">
        <div class="card border-0 bg-light mt-3" v-if="addNew">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="">{{ 'Title' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="newPromoCode.name"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="">{{ 'Type' | translate }}</label>
                  <select class="form-select" v-model="newPromoCode.type">
                    <option value="percentage">
                      {{ 'percentage based' | translate }}
                    </option>
                    <option value="amount">
                      {{ 'amount based' | translate }}
                    </option>
                  </select>
                </div>
              </div>



              <div class="col-6">
                <div class="mb-3">
                  <label for="">{{ 'Code' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="newPromoCode.code"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label for="">{{ 'Value' | translate }}</label>
                  <div
                    class="input-group"
                    v-if="newPromoCode.type === 'amount'"
                  >
                    <input
                      type="number"
                      class="form-control text-end"
                      v-model="newPromoCode.amount"
                    />

                    <div class="input-group-append">
                      <span class="input-group-text">
                        {{ (newPromoCode.amount / 100).toFixed(2) }}
                      </span>
                    </div>
                  </div>

                  <input
                    v-else
                    type="text"
                    v-mask="'####'"
                    class="form-control"
                    v-model="newPromoCode.amount"
                  />
                  <small v-if="newPromoCode.type === 'percentage'">
                    % {{ 'off purchase' | translate }}
                  </small>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="exampleRadios1"
                      value="all"
                      v-model="newPromoCode.mode"
                    />
                    <label class="form-check-label" for="exampleRadios1">
                      {{ 'All' | translate }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="exampleRadios2"
                      value="subscription"
                      v-model="newPromoCode.mode"
                    />
                    <label class="form-check-label" for="exampleRadios2">
                      {{ 'Subscription' | translate }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="exampleRadios3"
                      value="single"
                      v-model="newPromoCode.mode"
                    />
                    <label class="form-check-label" for="exampleRadios3">
                      {{ 'Single payment products' | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="newPromoCode.mode === 'single'">
                <div class="mb-3">
                  <Select
                    inputId="courses"
                    v-model="newPromoCode.course_id"
                    autocomplete="off"
                    :reduce="(c) => c.id"
                    label="title"
                    :options="courses"
                    :placeholder="$t('Choose product')"
                  ></Select>
                </div>
              </div>
              <div
                class="col-md-12"
                v-if="newPromoCode.mode === 'subscription'"
              >
                <div class="mb-3">
                  <select
                    class="form-select"
                    v-model="newPromoCode.membership_option"
                  >
                    <option value="">{{ 'all' | translate }}</option>
                    <option value="1">{{ 'monthly' | translate }}</option>
                    <option value="3">{{ 'quarterly' | translate }}</option>
                    <option value="6">{{ 'half yearly' | translate }}</option>
                    <option value="12">{{ 'yearly' | translate }}</option>
                    <option value="-1">{{ 'forever' | translate }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="form-check form-switch">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :checked="newPromoCode.is_active"
                      @click="newPromoCode.is_active = !newPromoCode.is_active"
                    />
                    <label
                      class="form-check-label"
                      @click="newPromoCode.is_active = !newPromoCode.is_active"
                    >
                      {{ 'Active' | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center">
                <button class="btn btn-primary" @click="createPromoCode">
                  {{ 'Add' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table mt-3">
      <thead>
        <tr>
          <th class="border-0 text-uppercase">{{ 'Active' | translate }}</th>
          <th class="border-0 text-uppercase">{{ 'Title' | translate }}</th>
          <th class="border-0 text-uppercase">{{ 'Code' | translate }}</th>
          <th class="border-0 text-uppercase"></th>
          <th class="border-0 text-uppercase text-end">
            {{ 'Value' | translate }}
          </th>
          <th class="border-0 text-uppercase">{{ 'Type' | translate }}</th>
          <th class="border-0 text-uppercase">{{ 'Product' | translate }}</th>
          <th class="border-0"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="code in promoCodes" :key="code.index">
          <td>
            <div class="form-check form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                @click="toggle(code)"
                :checked="code.is_active"
              />
              <label class="form-check-label" @click="toggle(code)"></label>
            </div>
          </td>
          <td>{{ code.name }}</td>
          <td>{{ code.code }}</td>
          <td>{{ `/?promo_code=${code.code}` }}</td>
          <td class="text-end">{{ code.type === 'percentage' ? code.amount : code.amount/100 }}</td>
          <td>{{ code.type === 'percentage' ? '%' : '$' }}</td>
          <td>
            {{ `${product(code)}` }}
          </td>
          <td class="text-end">
            <div class="dropdown">
              <a
                href="#"
                role="button"
                id="dropdownMenuLink"
                 data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <a
                  class="dropdown-item"
                  href="#"
                  @click="deletePromoCode(code)"
                >
                  {{ 'Delete' | translate }}
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import Select from 'vue-select'

export default {
  components: {
    Select,
  },
  directives: {
    mask,
  },
  data() {
    return {
      newPromoCode: {
        type: 'percentage',
        title: '',
        code: '',
        amount: '',
        mode: 'all',
        membership_option: null,
        course_id: null,
        is_active: true,
      },
      addNew: false,
    }
  },
  mounted() {
    this.getIndex()
    this.getCourses()
  },
  methods: {
    product(code) {
      if (code.mode === 'subscription') {
        return `subscription ${
          code.membership_option ? code.membership_option : 'all'
        }`
      } else if (code.mode === 'single') {
        return _.get(
          this.courses.find((c) => c.id === code.course_id),
          'title',
        )
      }
      return 'all'
    },
    catchErrors(error) {
      if (error.response && error.response.status === 419) {
        this.$root.$emit(
          'flash',
          this.$t('Your session has expired - please reload'),
          'warning',
        )
      } else if (error.response && error.response.status === 422) {
        iziToast.warning({
          title: 'Warning',
          message: this.$t('Validation error'),
          position: 'bottomLeft',
        })
      } else {
        console.error(error)
      }
    },
    index() {
      return this.$api.promoCodesIndex()
    },
    update(id, data) {
      return this.$api.promoCodesUpdate(id, data)
    },
    create(data) {
      return this.$api.promoCodesCreate(data)
    },
    delete(id) {
      return this.$api.promoCodesDelete(id)
    },
    validatePromoCode() {
      if (this.amount > 100) {
        this.amount = 100
      }
    },
    createPromoCode() {
      this.validatePromoCode()

      this.create(this.newPromoCode)
        .then(({ data }) => {
          this.$store.commit('promoCodesUpdate', [data, ...this.promoCodes])
          this.newPromoCode = {
            type: 'percentage',
            name: '',
            code: '',
            amount: '',
            mode: 'all',
            membership_option: null,
            course_id: null,
            is_active: true,
          }
          this.addNew = false
          iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
        })
        .catch(this.catchErrors)
    },
    deletePromoCode(code) {
      this.delete(code.id)
        .then(() => {
          this.$store.commit(
            'promoCodesUpdate',
            this.promoCodes.filter((el) => el.id !== code.id),
          )
          iziToast.success({
            title: 'OK',
            message: this.$t('Deleted'),
            position: 'bottomLeft',
          })
        })
        .catch(this.catchErrors)
    },
    toggle(code) {
      this.update(code.id, {
        is_active: !code.is_active,
      })
        .then(({ data }) => {
          this.$store.commit('promoCodeUpdate', data)
          iziToast.success({
            title: 'OK',
            message: this.$t('Saved'),
            position: 'bottomLeft',
          })
        })
        .catch(this.catchErrors)
    },
    getIndex() {
      this.index()
        .then(({ data }) => {
          this.$store.commit('promoCodesUpdate', data)
        })
        .catch(this.catchErrors)
    },
    getCourses() {
      this.$api.json
        .courses()
        .then(({ data }) => {
          this.$store.commit('coursesUpdate', data)
        })
        .catch(this.catchErrors)
    },
  },
  computed: {
    promoCodes() {
      return this.$store.state.promoCodes
    },
    courses() {
      return this.$store.state.courses
    },
  },
}
</script>
